import React, { Component } from 'react'

const DataContext = React.createContext({

})


export default DataContext;